import PageMeta from '@/components/feature/PageMeta';
import HeroSection from './components/HeroSection';
import CategoryTabs from './components/CategoryTabs';
import FeaturedComics from './components/FeaturedComics';
import LatestUpdates from './components/LatestUpdates';
import PopularComics from './components/PopularComics';
import Newsletter from './components/Newsletter';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩漫屋',
    url: 'http://nheap.cn/',
    description: '韩漫屋-好看的韩国漫画免费阅读平台',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'http://nheap.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩漫屋',
    url: 'http://nheap.cn/',
    description: '韩漫屋平台汇集了好看的韩国漫画，支持韩漫免费阅读，提供专业贴心的漫画服务',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'hello@nheap.cn',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '韩漫屋是什么平台？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '韩漫屋是一个专注于韩国漫画的免费阅读平台，汇集了恋爱、奇幻、动作、悬疑等多种类型的韩漫作品，每日更新热门漫画，为读者提供优质的在线阅读体验。',
        },
      },
      {
        '@type': 'Question',
        name: '韩漫屋的漫画可以免费阅读吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，韩漫屋支持韩漫免费阅读。平台上的所有漫画作品都可以免费在线阅读，无需付费订阅，让每一位漫画爱好者都能畅享阅读乐趣。',
        },
      },
      {
        '@type': 'Question',
        name: '如何通过韩漫网址访问韩漫屋？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以直接在浏览器中输入韩漫屋的官方网址 nheap.cn 来访问平台。韩漫网址简洁易记，支持PC端和移动端访问，随时随地畅读好看的韩国漫画。',
        },
      },
      {
        '@type': 'Question',
        name: '韩漫屋有哪些漫画类型？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '韩漫屋涵盖恋爱、奇幻、动作、悬疑、搞笑、剧情、惊悚等多种漫画类型，满足不同读者的阅读偏好。每周持续更新新作品，保持内容多样性。',
        },
      },
    ],
  },
];

export default function Home() {
  return (
    <>
      <PageMeta
        title="好看的韩国漫画-韩漫免费阅读-韩漫网址-韩漫屋"
        description="韩漫屋平台汇集了好看的韩国漫画，支持韩漫免费阅读，通过韩漫网址快速访问韩漫屋，享受专业贴心的漫画服务。每日更新热门韩漫，涵盖恋爱、奇幻、动作、悬疑等多种类型。"
        keywords="好看的韩国漫画, 韩漫免费阅读, 韩漫网址, 韩漫屋"
        canonicalUrl="http://nheap.cn/"
        jsonLd={homeJsonLd}
      />

      <main>
        <article>
          <HeroSection />
          <CategoryTabs />
          <FeaturedComics />
          <LatestUpdates />
          <PopularComics />
          <Newsletter />
        </article>
      </main>
    </>
  );
}
